import * as React from 'react';
import './Claim.scss';

import { CLAIMS_PATH } from '../../helpers/routes';
import { ClaimService, StoreService, UserService } from 'services/ApiService';
import Loader, { LoadHolder } from 'components/Loader';
import Gallery from 'components/Gallery';
import Select from 'react-select';
import {
  Claim, ClaimType, Item, Store, User, transformClaim,
  ToastState, UserType, isAlertClaimType, ClaimStatus, mapClaimStatus, AlertType,
} from 'types';
import { Link, Redirect } from 'react-router-dom';
import { DateTime } from 'luxon';
import ReactTable, { ReactTableDefaults, Column } from 'react-table';
import { IoInformatcircled } from 'react-icons/lib/io';

import { titleCase } from 'change-case';

import { DateCell, BooleanCell, TooltipHeader, SearchFilter, DropdownFilter, TooltipCell } from 'helpers/Table';

import Modal from 'components/Modal';
import Toast from 'components/Toast';
import AssignForm from 'components/AssignForm';
import ReturnInvoiceForm from 'components/ReturnInvoiceForm';

const BasicInfo = ({ claim, store, user, currentUser, viewOnly }: { claim: Claim<Item>, store: Store, user: User, currentUser?: User, viewOnly: boolean }) => {
  let distinctPurchseNumbers: Set<Number> = new Set;
  let distinctItemNumbers: Set<Number> = new Set;
  let distinctItemQuantities: Set<Number> = new Set;
  claim.items.forEach(item => {
    distinctItemQuantities.add(item.units as Number);
    if (!distinctItemNumbers.has(item.itemNumber)) {
      distinctItemNumbers.add(item.itemNumber);
    }
    if (item.purchaseNumber !== null && !distinctPurchseNumbers.has(item.purchaseNumber)) {
      distinctPurchseNumbers.add(item.purchaseNumber);
    }
    if (claim.type === 'recall') {
      item.disposition = claim.disposition;
      item.alertNumber = claim.alert && claim.alert.alertNumber ? claim.alert.alertNumber : 0;
    }
  });
  // let purchaseNumbers = Array.from(distinctPurchseNumbers).join(', ');
  let itemNumbers = Array.from(distinctItemNumbers).map(num => num >= 0 ? num.toString() : 'Custom').join(', ');
  let itemQuantities = Array.from(distinctItemQuantities).join(', ');

  const columnGroup = (
    <colgroup>
      <col style={{ width: '30%' }} />
      <col />
    </colgroup>);
  const tableProps = { className: 'info-table', cellSpacing: 0 };
  
  return (
    <div className="basic-info">
      <div className="info-photos">
        {/* <strong className="heading">Bill of Lading or Order Invoice Photos</strong> */}
        {claim.photos.length ? (
          <Gallery photos={claim.photos} />
        ) : (
          <p>No photos attached</p>
        )}
      </div>
      <div className="info-section">
        {/* <h2>
          Claim Info {'(' + (claim.type === 'recall' && claim.alert ?
           mapClaimType(claim.alert.type) : mapClaimType(claim.type)) + ')'}
        </h2> */}
        <table {...tableProps}>
          {columnGroup}
          <tbody>
            {/* <tr><td>Claim ID Number</td><td>{claim.id}</td></tr>
            <tr><td>Status</td><td style={{ textTransform: 'capitalize' }}>{claim.statusText}</td></tr> */}
            <tr>
              <td>Submission Date</td>
              <td>{claim.date.toLocaleString(DateTime.DATETIME_FULL)}</td>
            </tr>
            <tr>
              <td>Item Number(s)</td>
              <td>{itemNumbers}</td>
            </tr>
            {!isAlertClaimType(claim.type) ? (
              <>
                {/*<tr>
                  <td>Item Purchase Order Number(s)</td>
                  <td>{purchaseNumbers}</td>
                </tr>*/} 
                <tr>
                  <td>Order Invoice Number</td>
                  <td>{claim.bolNumber}</td>
                </tr>
                <tr>
                  <td>Carrier Name</td>
                  <td>{claim.carrierName}</td>
                </tr>
                {/* <tr>
                  <td>Frozen Load</td>
                  <td>
                    {claim.frozenLoad === false
                      ? 'No'
                      : claim.frozenLoad
                      ? 'Yes'
                      : 'N/A'}
                  </td>
                </tr> */}
                <tr>
                  <td>Seal Intact</td>
                  <td>
                    {claim.sealIntact === false
                      ? 'No'
                      : claim.sealIntact
                      ? 'Yes'
                      : 'N/A'}
                  </td>
                </tr>
                <tr>
                  <td>Seal Number</td>
                  <td>{claim.sealNumber}</td>
                </tr>
                {/* <tr>
                  <td>Goods Received Date</td>
                  <td>
                    {claim.goodsReceivedDate
                      ? claim.goodsReceivedDate.toLocaleString(
                          DateTime.DATETIME_FULL
                        )
                      : ''}
                  </td>
                </tr> */}
                
              </>
            ) : (
              <>
                <tr>
                  <td>Alert #</td>
                  <td>{claim.alert && claim.alert.alertNumber}</td>
                </tr>
                <tr>
                  <td>Item Quantity (units)</td>
                  <td>{itemQuantities}</td>
                </tr>
                  {claim.alert && claim.alert.type === AlertType.QAAlert && 
                  <>
                    <tr>
                      <td>Disposition</td>
                      <td>
                        {claim.disposition
                          ? claim.disposition.charAt(0).toUpperCase() +
                            claim.disposition.slice(1)
                          : ''}
                      </td>
                    </tr>
                    <tr>
                      <td>Store Email</td>
                      <td>
                        {claim.storeEmail}
                      </td>
                    </tr>
                    <tr>
                      <td>Store Owner Name</td>
                      <td>
                        {claim.storeOwnerName}
                      </td>
                    </tr>
                    {claim?.storePhoneNumber !== '' && (
                      <tr>
                        <td>Store Phone Number</td>
                        <td>
                          {(claim.storePhoneNumber && claim.storePhoneNumber.length === 10) ? claim.storePhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : claim.storePhoneNumber}
                        </td>
                      </tr>
                    )}
                  </>
                  }
              </>
            )}
            <tr>
              <td>Assigned To</td>
              <td>
                <AssignForm
                  disabled={
                    currentUser &&
                    (currentUser.type === UserType.QAAdmin || 
                    currentUser.type === UserType.LCBOReporter || 
                    (['approved', 'completed', 'validating', 'pending'].indexOf(claim.status) === -1 && 
                      claim.type === 'recall' && 
                      claim.alert && 
                      claim.alert.type === AlertType.QAAlert
                    ))
                  }
                  claimType={claim.type}
                  id={claim.id}
                  default={claim.assignedTo}
                />
              </td>
            </tr>
            <tr>
              <td>{claim.alert && claim.alert.type === AlertType.QAAlert ? 'Submitted on Behalf of' : 'Completed By'}</td>
              <td>{claim.completedBy}</td>
            </tr>
            {claim.alert && claim.alert.type === AlertType.QAAlert && 
              <tr>
                <td>Title</td>
                <td>
                  {claim.completedByTitle}
                </td>
              </tr>
            }
            {currentUser && [UserType.Admin, UserType.LCBO, UserType.LCBOReporter].indexOf(currentUser.type) !== -1 ? <tr>
                <td>Return Invoice</td>
                <td>
                  <ReturnInvoiceForm
                    claimType={claim.type}
                    id={claim.id}
                    default={claim.returnInvoice}
                    disabled={currentUser.type === UserType.LCBOReporter}
                  />
                </td>
              </tr> : null              
            }
            {columnGroup}
            <tr>
              <td>Store Operator Name</td>
              <td>{store.storeOperatorName}</td>
            </tr>
            <tr>
              <td>Store Operator Number</td>
              <td>{store.storeOperatorNumber}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{user.email}</td>
            </tr>
            <tr>
              <td>Phone Number</td>
              <td>{store.phoneNumber}</td>
            </tr>
            <tr>
              <td>Contact Name</td>
              <td>{user.contactName}</td>
            </tr>
            <tr>
              <td>Address</td>
              <td>{store.address}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

const itemNumberColumn = {
  Header: <TooltipHeader value="LCBO Item #" />,
  accessor: 'itemNumber',
  Filter: SearchFilter,
  Cell: props => <div>{props.value > -1 ? props.value : 'Custom'}</div>
};
const purchaseNumberColumn = {
  Header: <TooltipHeader value="Purchase Order Number" />,
  accessor: 'purchaseNumber',
  Filter: SearchFilter,
};
const itemDescriptionColumn = {
  Header: <TooltipHeader value="Product Name" />,
  accessor: 'productDescription',
  Filter: SearchFilter,
  filterMethod: (filter, row) => {
    return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
  }
};
const unitsColumn = {
  Header: <TooltipHeader value="Units" />,
  accessor: 'units',
  Filter: SearchFilter,
};
const casesColumn = {
  Header: <TooltipHeader value="Cases" />,
  accessor: 'cases',
  Filter: SearchFilter,
};
const alertNumberColumn = {
  Header: <TooltipHeader value="QA Alert #" />,
  accessor: 'alertNumber',
  Filter: SearchFilter,
};
const dispositionOptions = [{ value: 'destroy', label: 'Destroy' }, { value: 'return', label: 'Return' }];
const dispositionColumn = {
  Header: <TooltipHeader value="Disposition" />,
  accessor: 'disposition',
  Filter: ({onChange, filter}) => (
    DropdownFilter({ onChange, filter, options: dispositionOptions})
  ),
  filterMethod: (filter, row) => (
    !filter.value || row[filter.id].toLowerCase() === filter.value.value.toLowerCase()
  ),
};
const ItemEndColumns = (disabled: boolean, toggleApproval: Function, showItem: Function) => [
  {
    Header: <TooltipHeader value="Details" />,
    sortable: false,
    filterable: false,
    /* tslint:disable-next-line */
    Cell: function (props: any) {
      return (
        <button
          className="tableBtn"
          onClick={() => showItem(props.original.id)}
        >
          <span><IoInformatcircled /></span>
        </button>
      );
    }
  }, {
    Header: <TooltipHeader value="Approve?" />,
    accessor: 'isApproved',
    /* tslint:disable-next-line */
    Cell: function (props: any) {
      return (
        <label>
          <input
            type="checkbox"
            onChange={() => toggleApproval(props.original.id)}
            disabled={props.value === -1 || disabled}
            checked={props.value}
          /> {props.value === -1 ? <Loader /> : (props.value ? ' ' : ' ')}
        </label>
      );
    },
    Filter: ({onChange, filter}) => (
      DropdownFilter({
        onChange, filter, options:
          [{ value: true, label: 'Approved' }, { value: false, label: 'Not Approved' }]
      })
    ),
    filterMethod: (filter, row) => {
      return filter.value ? row[filter.id] === filter.value.value : true; 
    }
  }
];

function mapClaimCategory(claimCategory: Item['claimCategory']): 'Shortage' | 'Overage' | 'Breakage' {
  let newCategory;
  switch (claimCategory) {
    case 'short':
      newCategory = 'Shortage';
      break;
    case 'over':
      newCategory = 'Overage';
      break;
    case 'damage':
      newCategory = 'Breakage';
      break;
    default:
      break;
  }
  return newCategory;
}

function mapClaimType(type: ClaimType | 'price_recall' | 'qa_alert'): 
'Adjustment' | 'Recall' | 'Wine Floor Price Product Recall' | 'QA Recall' | 'Refund' {
  let newType: 'Adjustment' | 'Recall' | 'Wine Floor Price Product Recall' | 'QA Recall' | 'Refund' = 'QA Recall';
  switch (type) {
    case 'recall':
      newType = 'Recall';
      break;
    case 'adjustment':
      newType = 'Adjustment';
      break;
    case 'refund':
      newType = 'Refund';
      break;
    case 'price_recall':
      newType = 'Wine Floor Price Product Recall';
      break;
    case 'qa_alert':
      newType = 'QA Recall';
      break;
    default:
      break;
  }
  return newType;
}

const skidOptions = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
const breakageOptions = [{ label: 'Wet', value: 'wet' }, { label: 'None', value: 'none' }];
const categoryOptions = ['Breakage', 'Overage', 'Shortage'].map((cat) => ({label: cat, value: cat}));
const columnSuppliers: Record<ClaimType,
  (disabled: boolean, toggleApproval: Function, showItem: Function) => Column[]> = {
  recall: (disabled: boolean, toggleApproval: Function, showItem: Function) => [
    itemNumberColumn,
    alertNumberColumn,
    itemDescriptionColumn,
    dispositionColumn,
    unitsColumn,
    casesColumn,
    ...ItemEndColumns(disabled, toggleApproval, showItem),
  ],
  refund: (disabled: boolean, toggleApproval: Function, showItem: Function) => [
    itemNumberColumn,
    purchaseNumberColumn,
    itemDescriptionColumn,
    unitsColumn,
    casesColumn,
    {
      Header: <TooltipHeader value="Receival Date" />,
      accessor: 'receivalDate',
      filterable: false,
      Cell: DateCell
    },
    ...ItemEndColumns(disabled, toggleApproval, showItem)
  ],
  adjustment: (disabled: boolean, toggleApproval: Function, showItem: Function) => [
    itemNumberColumn,
    purchaseNumberColumn,
    {
      Header: <TooltipHeader value="Product Name" />,
      accessor: 'productDescription',
      Filter: SearchFilter,
      filterMethod: (filter, row) => {
        return row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
      }
    }, {
      Header: <TooltipHeader value="Category" />,
      id: 'claimCategory',
      accessor(row: Item) {
        return mapClaimCategory(row.claimCategory);
      },
      Filter: ({ onChange, filter }) => ( DropdownFilter({ onChange, filter, options: categoryOptions })),
      filterMethod: (filter, row) => {
        return !(filter.value) ? true : row[filter.id] === filter.value.value;
      }
    }, {
      Header: <TooltipHeader value="Item Received" />,
      accessor: 'itemReceived',
      Cell: BooleanCell,
      Filter: ({ onChange, filter }) => ( DropdownFilter({ onChange, filter, options: skidOptions })),
      filterMethod: (filter, row) => (
        filter.value ? row[filter.id] === filter.value.value : true
      )
      
    }, {
      Header: <TooltipHeader value="Receival Date" />,
      id: 'receivalDate',
      accessor: (row: any) => {
        return !row.receivalDate || row.receivalDate === null ? '' : row.receivalDate.substring(0, 10);
      },
      Filter: SearchFilter
    },
    {
      Header: <TooltipHeader value="Units" />,
      accessor: 'unitsClaimed',
      Filter: SearchFilter,
    },
    {
      Header: <TooltipHeader value="Cases" />,
      accessor: 'cases',
      Filter: SearchFilter,
    },
    {
      Header: <TooltipHeader value="Breakage Type" />,
      accessor: 'breakageType',
      Filter: ({ onChange, filter }) => ( DropdownFilter({ onChange, filter, options: breakageOptions })),
      filterMethod: (filter, row) => (
        filter.value ? row[filter.id] === filter.value.value : true
      )
    },
    ...ItemEndColumns(disabled, toggleApproval, showItem)
  ],
};

type ItemsInfoProps = {
  claim: Claim<Item>, patch: (claim: Claim<Item>) => void,
  showItem: (id: number) => void, viewOnly: boolean
};
class ItemsInfo extends React.Component<ItemsInfoProps, {}> {

  // tooltipCellLinker = ClickableTooltipCell((info) => this.props.showItem);

  toggleApproval = (id: number | string) => {
    this.setState({ loading: true });
    const item = this.props.claim.items.find(claimItem => claimItem.id === id)!!;
    const newApprovalStatus = !item.isApproved;
    item.isApproved = -1;
    this.props.patch(this.props.claim);
    ClaimService.patchItem(this.props.claim,
      { id: item.id, isApproved: newApprovalStatus }).then(data => {
      Object.assign(item, data);
      this.props.patch(this.props.claim);
      this.setState({ loading: false });
    });
  }

  render() {
    const { claim, showItem, viewOnly } = this.props;
    const editable = ['completed', 'incomplete', 'draft'].indexOf(claim.status) !== -1 || viewOnly;
    return (
        <ReactTable
          className="claim-items-table"
          minRows={0}
          data={claim.items}
          defaultPageSize={10}
          filterable={true}
          columns={columnSuppliers[claim.type](editable, this.toggleApproval, showItem)}
          column={{
            ...ReactTableDefaults.column,
            Cell: TooltipCell,
          }}
        />
    );
  }
}

type CommentInfoProps = { claim: Claim<Item>, patch: (claim: Claim<Item>) => void, viewOnly: boolean };
class CommentInfo extends React.Component<CommentInfoProps, { loading: boolean, message: string }> {
  constructor(props: CommentInfoProps) {
    super(props);
    this.state = {
      loading: false,
      message: ''
    };
  }
  onChange = (e) => {
    this.setState({ message: e.target.value });
  }
  onSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    ClaimService.comment(this.props.claim, this.state.message.trim()).then(newComment => {
      this.props.claim.comments.push(newComment);
      this.props.patch(this.props.claim);
      this.setState({ loading: false, message: '' });
      window.scrollTo(0, document.body.getBoundingClientRect().height);
    }, () => {
      this.setState({ loading: false, message: '' });
    });
  }
  render() {
    const { claim, viewOnly } = this.props;
    const { message, loading } = this.state;
    return (
      <div className="comment-info">
        <div className="comments">
          {claim.comments.map(comment => <div
            key={comment.id}
            className={'comment' + (comment.status ? ' status' : '')}
          >
            <strong>{comment.user.contactName}</strong>
            <p>{comment.status ? <> marked the claim as <strong>{comment.status}</strong></> : comment.message}</p>
            <div className="date">{typeof comment.createDate === 'string' ? DateTime.fromISO(comment.createDate).toLocaleString(DateTime.DATETIME_FULL) : comment.createDate.toLocaleString(DateTime.DATETIME_FULL)}</div>
          </div>)}
          {claim.comments.length ? null : <p>There are no comments</p>}
        </div>
        <form onSubmit={this.onSubmit}>
          <input
            value={message}
            disabled={loading || viewOnly}
            type="text"
            onChange={this.onChange}
            placeholder="Type your comment here..."
          />
          <button disabled={message.trim().length === 0 || loading || viewOnly}>
            <LoadHolder loading={loading}>Send</LoadHolder>
          </button>
        </form>
      </div>
    );
  }
}

type ClaimProps = { match: { params: { id: string } } };
type ClaimState = {
  claim: Claim<Item> | null, loading: boolean, tab: string, openItem: Item | null, 
  showDeleteModal: boolean, toClaimsPage: boolean, showModal: boolean, comment: string,
  store: Store | null, user: User | null;
  authenticatedUser: undefined | User;
};

export default class ClaimView extends React.Component<ClaimProps, ClaimState> {
  constructor(props: ClaimProps) {
    super(props);
    this.state = {
      claim: null,
      loading: false,
      tab: 'basic',
      openItem: null,
      store: null,
      user: null,
      authenticatedUser: undefined,
      showDeleteModal: false,
      toClaimsPage: false,
      showModal: false,
      comment: '',
    };
  }

  reload = (showLoader: boolean = true) => {
    const urlId = this.props.match.params.id.split('-');
    UserService.fetch().then((currentUser) => {
      this.setState({ authenticatedUser: currentUser });
    });
    return new Promise((resolve, reject) => {
      this.setState({ loading: showLoader ? true : false }, () => {
        ClaimService.fetch(urlId[0] as ClaimType, Number(urlId[1])).then(claim => {
          this.setState({ claim: claim });
          StoreService.fetch(claim.storeId).then(storeData => {
            this.setState({ store: storeData });
            UserService.fetch(claim.userId).then(userData => {
              this.setState({ loading: false, user: userData });
              resolve(true);
            });   
          });
        });
      });
    });
  }
  patch = (claim: Claim<Item>) => {
    this.setState({ claim: transformClaim(claim.type, claim) });
  }
  openTab = (tab: string) => {
    this.setState({ tab });
  }
  showItem = (id: number) => {
    const item = this.state.claim!!.items.find(claimItem => claimItem.id === id)!!;
    this.setState({ openItem: item });
  }
  closeItem = () => {
    this.setState({ openItem: null });
  }
  componentDidMount() {
    this.reload();
  }
  formatGenericField(fieldData: Item[keyof Item], key: keyof Item) {
    if (typeof fieldData === 'boolean') {
      return fieldData ? 'Yes' : 'No';
    } else if (key === 'claimCategory') {
      return mapClaimCategory(fieldData as Item['claimCategory']);
    } else if (key === 'receivalDate' && typeof fieldData === 'string') {
      return DateTime.fromISO(fieldData).toLocaleString(DateTime.DATE_FULL);
    } else if (key === 'itemNumber' && fieldData === -1) {
      return 'Custom';
    }
    return fieldData ? fieldData.toString() : '';
  }
  showModal = () => {
    this.setState({ showModal: true });
  }
  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  }
  hideModal = () => {
    this.setState({ showModal: false, comment: '' });
  }
  hideDeleteModal = () => {
    this.setState({ showDeleteModal: false, comment: '' });
  }
  deleteClaim = async (claim) => {
    this.setState({ loading: true });
    await ClaimService.delete(claim.type, claim.id);
    this.setState({ loading: false });
    this.setState({ toClaimsPage: true });
    Toast.present({ message: 'Claim was successfully deleted!' }, ToastState.SUCCESS);
  }
  onChange = (e) => {
    this.setState({ comment: e.target.value.replace('\n', '') });
  }
  mark = (status: 'incomplete' | 'completed' | 'validating' | 'pending' | 'draft' | 'submitted') => {
    const { claim } = this.state;
    if (claim) {
      this.setState({ loading: true }, () => {
        ClaimService.patch({ id: claim.id, type: claim.type, status }).then(newClaim => {
          if (status === 'completed' && this.state.comment.trim() !== '') {
            ClaimService.comment(claim, this.state.comment).then(newComment => {
              this.setState({ loading: false, showModal: false });
              newClaim.comments.push(newComment);
              this.patch(Object.assign(claim, newClaim));
            }).catch(err => {
              this.setState({ loading: false });
            });
          } else {
            this.setState({ loading: false, showModal: false });
            this.patch(Object.assign(claim, newClaim));
          }
        }).catch(err => {
          this.setState({ loading: false });
        });
      });
    }
  }
  isAvailable = (status: 'incomplete' | 'completed' | 'validating' | 'pending' | 'draft' | 'submitted' | 'approved') => {
    const {claim, loading, authenticatedUser} = this.state;
    if (loading || !claim || !authenticatedUser) {
      return false;
    }
    const defaultOptions = new Set(['incomplete', 'pending', 'completed', 'validating', 'approved']);

    switch (authenticatedUser.type) {
      case UserType.LCBO:
      case UserType.Admin:
        return defaultOptions.has(status);
      case UserType.QAAdmin:
        return status === 'approved' || status === 'incomplete';
      default:
        return false;
    }
  }

  capitalize = (str: string) => {
    const [first, ...rest] = str;
    const res = first.toUpperCase() + rest.join('');
    return res;
  }

  toggleApproval = (id: number | string) => {
    if (!this.state.claim) { return; }
    this.setState({ loading: true });
    const item = this.state.claim.items.find(claimItem => claimItem.id === id)!!;
    const newApprovalStatus = !item.isApproved;
    item.isApproved = -1;
    this.patch(this.state.claim);
    ClaimService.patchItem(this.state.claim, { id: item.id, isApproved: newApprovalStatus }).then(data => {
      Object.assign(item, data);
      if (this.state.claim) { this.patch(this.state.claim); }
      this.setState({ loading: false });
    });
  }

  render() {
    const { loading, tab, claim, openItem, store, user, authenticatedUser, showDeleteModal, showModal, comment, toClaimsPage } = this.state;
  
    // Reporter users don't see the details page.
    if (authenticatedUser && !UserType.canViewClaimDetails(authenticatedUser)) {
      return <Redirect to={CLAIMS_PATH} />;
    }
    return (
      <div className="claim">
        {toClaimsPage && <Redirect to="" />}
        <Modal large={true} visible={!!openItem} onClose={this.closeItem}>
          {openItem && claim && user ? <div className="item-modal">
            <div className="main">
              <div className="product-photos">
              {!openItem.photos.length ? <p>No photos provided</p> : null}
              <Gallery photos={openItem.photos} />
              </div>
              <div className="information">
              {Object.keys(openItem).filter(key => (key !== 'id' &&
                key !== 'createDate' &&
                key !== 'updateDate' &&
                (typeof openItem[key] === 'string' ||
                  typeof openItem[key] === 'number' ||
                  typeof openItem[key] === 'boolean')))
                .map(key => (
                  <>
                    <div className="info-table">
                      <div className="key">{titleCase(key)}:</div>
                      <div className="value">{' ' + this.formatGenericField(openItem[key], key as keyof Item)}</div>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="footer">
                <div>
                  <h2>Status: <strong>{openItem.isApproved ? 'Approved' : 'Not Approved'}</strong></h2>
              </div>
              {
                authenticatedUser && authenticatedUser.type !== UserType.LCBOReporter ? (
                  <div>
                    <button
                      onClick={() => this.toggleApproval(openItem.id)}
                    >
                      {openItem.isApproved ? 'Unapprove' : 'Approve'}
                    </button>
                  </div> 
                ) : null
              }
            </div>
          </div> : null}
        </Modal>
        <Modal visible={showDeleteModal} onClose={this.hideDeleteModal}>
          <div className="claim-modal">
            <h3>Are you sure you want to delete this claim?</h3>
            <div className="actions-info-modal-input">
              <button id="toast-cancel-button" disabled={loading} onClick={() => this.hideDeleteModal()}>
                <LoadHolder loading={loading}>Cancel</LoadHolder>
              </button>
              <button id="toast-delete-button" disabled={loading} onClick={() => this.deleteClaim(claim)}>
                <LoadHolder loading={loading}>Delete Permanently</LoadHolder>
              </button>
            </div>
          </div>
        </Modal>
        
        <Link to={CLAIMS_PATH} className="back">Back to Claims</Link>
        {user && authenticatedUser && claim && 
          <div className="header">
            <div>
            <h1>Claim #{claim.id} {'(' + (claim.type === 'recall' && claim.alert ? mapClaimType(claim.alert.type)
              : mapClaimType(claim.type)) + ')'}</h1>
              <span>Status: {claim.statusText}</span>
            </div>
            <div className="actions">
              {
                (authenticatedUser.type === UserType.QAAdmin) ? null : (
                  <>
                    <span>Mark Claim Status as: &nbsp;</span>
                    <Select
                      clearable={false}
                      className="dropdown" 
                      disabled={
                        authenticatedUser.type === UserType.LCBOReporter ||
                        ([UserType.QAAdmin, UserType.LCBO].indexOf(authenticatedUser.type) !== -1 && 
                          ['approved', 'validating', 'completed', 'pending'].indexOf(claim.status) === -1 && 
                          claim.type === 'recall' && claim.alert && claim.alert.type === AlertType.QAAlert) ||
                        loading
                      }
                      options={Object.keys(ClaimStatus).filter(
                      (option) => this.isAvailable(ClaimStatus[option])).map((claimStatus:
                        'draft' | 'submitted' | 'pending' | 'incomplete' | 'validating' | 'completed' | 'approved') =>
                        ({ value: ClaimStatus[claimStatus], label: mapClaimStatus(ClaimStatus[claimStatus]).split(' ').map(str => this.capitalize(str)).join(' ') }))}
                      value={claim.status}
                      onChange={(option) => {
                        option !== null && option.value === 'completed' ? this.showModal() : this.mark(option.value);
                      }}
                    />
                </>)
              }
            {
             [UserType.QAAdmin, UserType.Admin].indexOf(authenticatedUser.type) === -1 ? null : (
                <button
                  id="delete-button"
                  disabled={
                    (claim.alert && claim.alert.type === 'qa_alert' && authenticatedUser !== undefined && authenticatedUser.type === UserType.Admin &&
                      ['approved', 'completed', 'submitted', 'pending'].indexOf(claim.status) === -1) ||
                    loading
                  }
                  onClick={this.showDeleteModal}
                >
                  <LoadHolder loading={loading}>Delete this Claim</LoadHolder>
                </button>
              )
            }
            </div>
            <Modal visible={showModal} onClose={this.hideModal}>
              <div className="claim-modal">
                <h3>Mark Claim #{claim.id} Complete</h3>
                <div className="actions-info-modal-input">
                  <textarea
                    onChange={this.onChange}
                    disabled={loading}
                    value={comment}
                    placeholder="Type a completion message (optional)"
                  />
                  <button disabled={loading} onClick={() => this.mark('completed')}>
                    <LoadHolder loading={loading}>Confirm</LoadHolder>
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        }
        
        <div className="box">
          <div className="tabs">
            <button
              onClick={this.openTab.bind(this, 'basic')}
              className={'tab' + (tab === 'basic' ? ' active' : '')}
            >
              <span>Basic Information</span>
            </button>
            <button
              onClick={this.openTab.bind(this, 'items')}
              className={'tab' + (tab === 'items' ? ' active' : '')}
            >
              <span>Items</span>
            </button>
            <button
              onClick={this.openTab.bind(this, 'comments')}
              className={'tab' + (tab === 'comments' ? ' active' : '')}
            >
              <span>Comments</span>
            </button>
          </div>
          <div className="content">
            {loading || !claim || !store || !user ? <div className="loader-wrapper"><Loader /></div> : <div>
              <div className={'tab-content' + (tab === 'basic' ? ' active' : '')}>
                <BasicInfo 
                  claim={claim} 
                  store={store} 
                  user={user} 
                  currentUser={authenticatedUser} 
                  viewOnly={
                    authenticatedUser !== undefined && (authenticatedUser.type === UserType.LCBOReporter ||
                    (['validating', 'completed'].indexOf(claim.status) === -1
                    && authenticatedUser.type === UserType.LCBO))
                  }
                />
              </div>
              <div className={'tab-content' + (tab === 'items' ? ' active' : '')}>
                <ItemsInfo
                  claim={claim}
                  patch={this.patch}
                  showItem={this.showItem}
                  viewOnly={authenticatedUser !== undefined && authenticatedUser.type === UserType.LCBOReporter}
                />
              </div>
              <div className={'tab-content' + (tab === 'comments' ? ' active' : '')}>
                <CommentInfo
                  claim={claim}
                  patch={this.patch}
                  viewOnly={authenticatedUser !== undefined && authenticatedUser.type === UserType.LCBOReporter}
                />
              </div>
            </div>}
          </div>
        </div>
      </div>
    );
  }
} 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Claim/index.tsx